import React from "react";
import { Link } from "react-router-dom";

import { Checkbox, Rate, List, Button, DatePicker, Space, Select } from "antd";
import { FiUsers } from "react-icons/fi";
import { KEYS } from "../../../Config/Keys";
import { useNavigate } from "react-router-dom";

import { FaMapMarkerAlt } from "react-icons/fa";
import { SiNike } from "react-icons/si";
import dayjs from "dayjs";
import classes from "./index.module.css";
import moment from "moment";
import { EVENT_TYPES } from "../../../Config/helpers/constants";
import { totalAwardValue } from "../../../common/Utils";

const Events = ({ loading, Events, selectedOptions, handleCheckboxChange, resetFilter }) => {
  const navigate = useNavigate();
  const options = [
    { label: "Registration Open", name: "registrationStatus" },
    { label: "Prize Money", name: "prizeMoney" },
    { label: "Wildcards", name: "allowWildCard" },
    { label: "sponsors", name: "sponsors" }
  ];

  const dropdownRender = () => (
    <div style={{ padding: "5px" }}>
      {options.map((option) => (
        <Checkbox
          className={classes.checkboxitem}
          key={option.name}
          name={option.name}
          checked={selectedOptions[option.name]}
          onChange={(e) => handleCheckboxChange(e.target.name, e.target.checked)}
          style={{
            display: "flex",
            marginBottom: "8px",
            fontSize: "0.7rem",
            marginLeft: "0"
          }}>
          {option.label}
        </Checkbox>
      ))}
    </div>
  );

  return (
    <div className="">
      <div className={classes.checkboxContainer}>
        <Select
          placeholder="Event filters"
          style={{ width: "125px", fontSize: "0.8rem", padding: "0.2rem" }}
          dropdownRender={dropdownRender}
          allowClear
        />

        <Space direction="horizantal">
          <DatePicker
            activeBorderColor
            style={{ width: "125px", fontSize: "0.8rem", padding: "0.2rem" }}
            value={
              selectedOptions?.date === "" || !selectedOptions?.date
                ? undefined
                : moment(selectedOptions?.date)
            }
            onChange={(date) => {
              const formattedDate = date ? date.toISOString() : "";
              handleCheckboxChange("date", formattedDate);
            }}
          />
        </Space>

        <Button
          type="primary"
          size="small"
          shape="round"
          className={classes.clearFilterBtn}
          onClick={() => resetFilter("event")}>
          Clear Filter
        </Button>
      </div>
      <List
        itemLayout="horizontal"
        className="searchedlistItemParent"
        loading={loading}
        dataSource={Events || []}
        renderItem={(item, index) => {
          return (
            <List.Item
              key={index}
              onClick={() => {
                navigate(`/view/event/${item?._id}`, { state: "event" });
              }}
              className={classes.listContainer}>
              <div className={classes.mode}>
                <span className={classes.labelTag}>
                  <strong>
                    {" "}
                    {item?.type === EVENT_TYPES.SCRIM || item?.type === "event"
                      ? "Scrim"
                      : "Tournament"}
                  </strong>
                </span>
                {item.typeofsports && (
                  <div className={classes.topTitle}>
                    {item.typeofsports + "-"} <span>{item?.nameofsports?.toUpperCase()}</span>
                  </div>
                )}
              </div>

              <div className={classes.fileContainer}>
                <img src={KEYS.API + item?.file?.fileUrl} alt="" style={{ borderRadius: "50%" }} />
              </div>
              <div style={{ flex: 1, marginTop: "1rem" }}>
                <h3 className={classes.title}>
                  {" "}
                  {item?.name} <Rate count={1} defaultValue={item?.ratings || 0} />{" "}
                  <span>{item?.ratings || 0}</span>
                </h3>
                <h3 className={classes.panel}>By: {item?.panel?.name}</h3>
                <p className={classes.eventDate}>
                  {" "}
                  {item?.startDate ? dayjs(item?.startDate)?.format("DD MMMM YY") : ""}
                </p>
                <p className={classes.eventLocation}>
                  {" "}
                  <FaMapMarkerAlt />
                  {item?.city || "-"}
                </p>
                <div className={classes.searchListItemInfo}>
                  <span>
                    <FiUsers />
                  </span>
                  {item?.registerteams?.length + "/" + item?.totalSlots || 0} Teams
                </div>
                <div className={classes.btn}>
                  {item?.allowWildCard && (
                    <Link to="/" style={{ background: "#1890ff" }}>
                      Wildcards
                    </Link>
                  )}
                  {item?.registrationComplete && (
                    <Link to="/" style={{ background: "red" }}>
                      Registration closed
                    </Link>
                  )}
                  {!item?.registrationComplete &&
                    moment(new Date(item?.deadline).setHours(24)) >= new Date() && (
                      <Link to="/" style={{ background: "green" }}>
                        Registration Open
                      </Link>
                    )}
                </div>
              </div>
              <div className={classes.rewardContainer}>
                <div className={classes.bottomleft}>
                  <div className={classes.moneyIcon}>
                    <img alt="money" src="/images/icons/money-2.png" />
                    <span>Rs {item?.totalCash || totalAwardValue(item?.eventAwards) || 0} </span>
                  </div>
                  <div>
                    <img alt="certificates" src="/images/icons/cert-2.png" />
                    <span>{item?.totalCertificates || 0} certificates</span>
                  </div>
                  <div>
                    <img alt="shield" src="/images/icons/shield-2.png" />
                    <span>{item?.totalShields || 0} Shields</span>
                  </div>
                </div>
                <div className={classes.sponsors}>
                  <p>Sponsors:</p>
                  <div>
                    <SiNike />
                  </div>
                  <div
                    style={{
                      borderLeft: "0.5px solid #c3c3c3",
                      paddingLeft: "15px"
                    }}>
                    <SiNike />
                  </div>
                </div>
              </div>
            </List.Item>
          );
        }}
      />
    </div>
  );
};

export default Events;
